import { FilteredCommentType } from "store/analysisSettings/analysisSettingsSlice";

export const formatCommentListForBackEnd = (commentList: FilteredCommentType[]): string[] => {
  if (commentList.length === 0) return null;
  return commentList.map(
    (filteredComment) => filteredComment.selectAllEnum || filteredComment.comment
  );
};
